<template>
  <v-container class="pa-0 mt-0" fluid>
    <v-row>
      <v-col cols="2">
        <inventory-class-select-element
          v-model="classFilterId"
        />
      </v-col>
      <v-col cols="2">
        <v-autocomplete
          v-model="subClassFilterIds"
          label="Sub Classes"
          :items="filteredSubClasses"
          item-text="name"
          item-value="id"
          multiple
          clearable
        >
          <template #item="{ item }">
            <v-chip
              class="mt-1 mb-1"
              small
              text-color="white"
              style="cursor: pointer;"
              :color="item ? item.color : 'white'"
            >
              {{ item ? item.name : '' }}
            </v-chip>
          </template>
          <template #selection="{ item }">
            <v-chip
              class="mt-1 mb-1"
              small
              text-color="white"
              style="cursor: pointer;"
              :color="item ? item.color : 'white'"
            >
              {{ item ? item.name : '' }}
            </v-chip>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="2">
        <v-autocomplete
          v-model="itemFilterId"
          label="Inventory Item"
          :items="inventoryItems"
          item-text="name"
          item-value="id"
          hide-details
          clearable
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-0">
        <v-card elevation="0" outlined>
          <v-data-table
            fixed-header
            :headers="headers"
            :items="allocationData"
            :footer-props="footer"
            :items-per-page="pagination.itemsPerPage"
            :server-items-length="totalItems"
            :loading="loading"
            @update:options="updateOptions"
            disable-sort
            dense
          >
            <template #item="{ item }">
              <tr>
                <td>
                  <v-chip v-if="item.inventory_class_id in classMap" small :color="classMap[item.inventory_class_id].color" text-color="white">
                    {{ classMap[item.inventory_class_id].name }}
                  </v-chip>
                </td>
                <td>
                  <div v-for="subId in getSubClassIdsArray(item)" :key="`sub-${subId}`">
                    <v-chip v-if="subId in subclassMap" small :color="subclassMap[subId].color" text-color="white">
                      {{ subclassMap[subId].name }}
                    </v-chip>
                  </div>
                </td>
                <td>{{ item.material_id }} - {{ item.name }}</td>
                <td>{{ item.color_name }}</td>
                <!-- <td>{{ item.length }}</td> -->
                <td>{{ item.uom_name }}</td>
                <td>{{ item.qty_ordered || 0 }}</td>
                <td>{{ item.qty_pre_allocated || 0 }}</td>
                <td>{{ item.qty_allocated || 0 }}</td>
                <td>{{ (item.qty_on_hand || 0) - (item.qty_allocated || 0) }}</td>
                <td>{{ item.qty_on_hand || 0 }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import * as allocationApi from '@/api/InventoryAllocationApi';
import inventoryCategoriesApi from '../../api/InventoryCategoriesApi';
import InventoryClassSelectElement from '../elements/InventoryClassSelectElement.vue';

export default {
  components: {
    InventoryClassSelectElement
  },

  data: () => ({
    allocationData: [],
    headers: [
      { text: 'Inventory Class' },
      { text: 'Inventory Sub Classes' },
      { text: 'Inventory Item' },
      { text: 'Colour' },
      // { text: 'Length' },
      { text: 'UOM' },
      { text: 'Ordered' },
      { text: 'Pre-Allocated' },
      { text: 'Qty Allocated' },
      { text: 'Qty Unallocated' },
      { text: 'Total' },
    ],
    totalItems: 0,
    isInitialized: false,
    categories: [],
    subClasses: [],
    filteredSubClasses: [],
    inventoryItems: [],
    classFilterId: null,
    subClassFilterIds: [],
    categoryFilterId: null,
    itemFilterId: null,
    classMap: {},
    subclassMap: {},

    footer: {
      'items-per-page-options': [20, 50, 100, 500, 1000],
    },
    pagination: {
      page: 1,
      itemsPerPage: 25.
    },
    sort: {
      sortBy: 'id',
      sortDirection: 'desc'
    },

    loading: true,
    topSpaceHeight: 260,
  }),

  computed: {
    ...mapGetters([
    ]),
    ...mapState({
      user: (state) => state.user,
      search: (state) => state.search,
    }),
  },
  watch: {
    search() {
      this.loadTableData();
    },
    classFilterId() {
      this.filterSubClasses();
      if (this.isInitialized) this.loadTableData();
    },
    subClassFilterIds() {
      if (this.isInitialized) this.loadTableData();
    },
    categoryFilterId() {
      if (this.isInitialized) this.loadTableData();
    },
    itemFilterId() {
      if (this.isInitialized) this.loadTableData();
    },
    pagination() {
      if (this.isInitialized) this.loadTableData();
    }, 
  },
  created() {
    this.$api.inventoryClass.getList().then(res => {
      console.log(res)
      this.classMap = res.reduce((acc, x) => {
        acc[x.id] = x;
        return acc;
      }, {});
    });
    this.$api.inventorySubClass.getList().then(res => {
      console.log(res)
      this.subClasses = res;
      this.subclassMap = res.reduce((acc, x) => {
        acc[x.id] = x;
        return acc;
      }, {});
      this.filterSubClasses();
    });
    inventoryCategoriesApi.getList().then(res => this.categories = res);
    this.$api.inventoryItem.read().then(res => this.inventoryItems = res.data);
    this.loadTableData();
  },
  methods: {
    filterSubClasses() {
      this.filteredSubClasses = this.subClasses.filter(x => !this.classFilterId || x.inventory_class_id === this.classFilterId);
    },
    async loadTableData() {
      this.loading = true;
      const data = { 
        filters: { 
          category_id: this.categoryFilterId, 
          inventory_item_id: this.itemFilterId,
          class_id: this.classFilterId,
          subclass_ids: this.subClassFilterIds
        }, 
        pagination: this.pagination, 
        search: this.search 
      };

      const res = await allocationApi.getInventoryAllocation(data);
      console.log(res)
      this.allocationData = res.data;
      this.totalItems = res.total;
      this.loading = false;
      this.isInitialized = true;
    }, 

    updateOptions(newOptions) {
      this.pagination = newOptions;
      this.sort = {
        sortBy: newOptions.sortBy[0],
        sortDirection: newOptions.sortDesc[0],
      };
    },
    getSubClassIdsArray(row) {
      console.log(row)
      if (!row.sub_class_ids) return [];
      try {
        return JSON.parse(row.sub_class_ids);
      } catch (e) {
        console.error(e);
        return [];
      }
    }
  },
};
</script>
<style>
#paint-class-data-table tr:last-child {
  font-weight: bold;
}
</style>
